import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { formatAriaProperties } from '@dojo/widgets/common/util';

import css from '../css/tools-button.m.css';

export interface MicroToolsButtonProperties {
	/** Unique key */
	key?: string;
	/** Button label */
	labelText?: string;
	/** Custom aria attributes */
	aria?: { [key: string]: string | null };
	/** Whether the button is disabled or clickable */
	disabled?: boolean;
	/** The name of the button */
	name?: string;
	/** Handler for events triggered by button losing focus */
	onBlur?(): void;
	/** Handler for events triggered by a button click */
	onClick?(): void;
	/** Handler for events triggered by "on down" */
	onDown?(): void;
	/** Handler for events triggered by "on focus" */
	onFocus?(): void;
	/** `id` set on the root button DOM node */
	widgetId?: string;
	/** The title text for the button node */
	title?: string;
	/** Dark mode on? */
	darkMode?: boolean;
}

const factory = create({
	theme
}).properties<MicroToolsButtonProperties>();

export const MicroToolsButton = factory(({ id, properties, middleware: { theme } }) => {
	const {
		labelText = '',
		aria = {},
		disabled = false,
		name,
		onBlur,
		onClick,
		onDown,
		onFocus,
		widgetId = `button-${id}`,
		title = '',
		darkMode = false
	} = properties();
	const fixedCss = theme.classes(css);

	const label = v('span', {}, [labelText]);

	const overrides = {
		'@dojo/widgets/button': {
			root: [fixedCss.root],
			text: [fixedCss.text],
			contained: [fixedCss.contained],
			outlined: [fixedCss.outlined],
			popup: [fixedCss.popup],
			label: [fixedCss.label],
			icon: [fixedCss.icon],
			iconOnly: [fixedCss.iconOnly],
			disabled: [fixedCss.disabled]
		}
	};

	return v('div', { classes: [darkMode ? fixedCss.dark : null] }, [
		w(
			Button,
			{
				classes: overrides,
				...formatAriaProperties(aria),
				disabled,
				name,
				onBlur,
				onClick,
				onDown,
				onFocus,
				widgetId,
				title,
				kind: 'outlined'
			},
			[
				{
					label
				}
			]
		)
	]);
});

export default MicroToolsButton;
